import { createSlice, PayloadAction } from '@reduxjs/toolkit';



type InitialStateType = {
    isFoolPopupService: boolean;
    isGroupSetting: boolean;
    isEdit:boolean
    isEditProfile:boolean
    isEditProfileStudent:boolean
    isChangePassword:boolean
    isProblemsClass:boolean
    isAddCut:boolean
    isLanguageLevel:boolean
    isFormAddTest:boolean
    isFormFeedback:boolean
    isFormReview:boolean
    isPopupsOffline:boolean
};

const initialState: InitialStateType = {
    isFoolPopupService: false,
    isGroupSetting: false,
    isEdit: false,
    isEditProfile: false,
    isEditProfileStudent: false,
    isChangePassword: false,
    isProblemsClass: false,
    isAddCut: false,
    isLanguageLevel: false,
    isFormAddTest: false,
    isFormFeedback: false,
    isFormReview: false,
    isPopupsOffline: false,
};

const slice = createSlice({
    name: 'popups',
    initialState,
    reducers: {
        isFoolPopupServiceAC: (state, action: PayloadAction<boolean>) => {
            state.isFoolPopupService = action.payload;
        },
        setSettingPopupsAC: (state, action: PayloadAction<boolean>) => {
            state.isGroupSetting = action.payload;
        },
        setEditAC: (state, action: PayloadAction<boolean>) => {
            state.isEdit = action.payload;
        },
        setEditProfileAC: (state, action: PayloadAction<boolean>) => {
            state.isEditProfile = action.payload;
        },
        setEditProfileStudentAC: (state, action: PayloadAction<boolean>) => {
            state.isEditProfileStudent = action.payload;
        },
        setChangePasswordAC: (state, action: PayloadAction<boolean>) => {
            state.isChangePassword = action.payload;
        },
        setProblemsClassAC: (state, action: PayloadAction<boolean>) => {
            state.isProblemsClass = action.payload;
        },
        setAddCutAC: (state, action: PayloadAction<boolean>) => {
            state.isAddCut = action.payload;
        },
        setLanguageLevelAC: (state, action: PayloadAction<boolean>) => {
            state.isLanguageLevel = action.payload;
        },
        setFormAddTestAC: (state, action: PayloadAction<boolean>) => {
            state.isFormAddTest = action.payload;
        },
        setFormFeedbackAC: (state, action: PayloadAction<boolean>) => {
            state.isFormFeedback = action.payload;
        },
        setFormReviewAC: (state, action: PayloadAction<boolean>) => {
            state.isFormReview = action.payload;
        },
        setPopupsOfflineAC: (state, action: PayloadAction<boolean>) => {
            state.isPopupsOffline = action.payload;
        },
    },
});

export const popupsReducer = slice.reducer;
export const { isFoolPopupServiceAC,setSettingPopupsAC,setEditAC,setEditProfileAC,setEditProfileStudentAC,setChangePasswordAC,setProblemsClassAC,setAddCutAC,setLanguageLevelAC,setFormAddTestAC,setFormFeedbackAC,setFormReviewAC,setPopupsOfflineAC } = slice.actions;
